<template>
  <div>
    <modal :isFooter="false" v-if="isModalVisible" @close="closeMCModal">
      <template v-slot:body>
        <AddMimk
          ref="modalBody"
          :isAppoint="isAppoint"
          :MasterClass="MasterClass"
          :isConfirm="true"
          @closeModal="closeMCModal"
        />
      </template>
    </modal>
    <modal
      v-if="cancelModalVisible"
      :title="$t('mc.modals.titles.mcCancel')"
      :scroll="false"
      @close="closeModals">
      <template v-slot:body>
        <span class="modal-cancel-text">
          {{$t('mc.manager.modalCancelMk.cancel')}}
        </span>
        <v-select
          class="select_reason"
          :options="lossReasons"
          :placeholder="$t('mc.placeholders.selectReason')"
          :clearable="false"
          :searchable="false"
          label="translated"
          @input="changeReason" />
      </template>
      <template v-slot:footer>
        <loader v-if="loadInModal"/>
        <template v-else>
          <button
            class="btn btn_danger btn_autowidth btn_is-margin-right"
            :disabled="!reason"
            @click="saveMkCancel">{{$t('mc.manager.modalCancelMk.buttons.cancel')}}</button>
          <button
            class="btn btn_danger btn_autowidth btn_transparent"
            @click="closeModals">{{$t('mc.manager.modalCancelMk.buttons.close')}}</button>
        </template>
      </template>
    </modal>
    <modal
      v-if="resheduleModalVisible"
      :title="$t('mc.modals.titles.reschedule')"
      :padding="'30px 30px 0px 30px'"
      @close="closeModals"
      width="1200px">
      <template v-slot:body>
        <select-date-mk
          type="reschedule"
          page="list-mk"
          :mkId="reshedule.mkIdForModal"
          :additionalInfoLoad="reshedule.additional_info"
          :reason="reason"
          :comment="resheduleComment"
          :triggerToDisableSaveButton="triggerToDisableSaveButton"
          @clearReason="clearReason"
          @toggleTriggerSaveButtonToDisable="toggleTriggerSaveButtonToDisable"
          @close="closeModals">
          <template #reasonAndComment>
            <ReasonSelectAndComment
              :rejectionReasons="$store.state.booking.lossReasons"
              @toggleTriggerSaveButtonToDisable="toggleTriggerSaveButtonToDisable"
              @changeReason="changeReason"
              @changeComment="changeResheduleComment"
            />
          </template>
        </select-date-mk>
      </template>
    </modal>

    <header-page
      :namePage="$t('pagesTitles.mc')"
      ref="headerPage"
      :links="$store.state.user.segmentM1Distribution ? $store.state.headerLinks.managerMcLinksWithTimetable : $store.state.headerLinks.managerMcLinks"
      @searchByAmoId="searchByAmoId"/>

    <div class="content">
      <loader v-if="loading"/>
      <div v-else>
        <v-select
          v-if="role === 'admin'"
          v-model="selectedM1"
          :options="m1List"
          label="name"
          class="m1-filter"
          :clearable="false"
          @input="filterByM1"
        />
        <h3 v-if="!allMk.length">{{$t('mc.hourConfirmation.notFound')}}</h3>
        <div v-else>
          <base-table
            :head="[
            $t('mc.tables.titles.client'),
            '',
            $t('mc.tables.titles.date'),
            $t('mc.tables.titles.client'),
            $t('mc.tables.titles.сontact'),
            $t('role.manager'),
            $t('mc.tables.titles.status'),
            $t('mc.tables.titles.action')]"
            :columnTemplates="columnSize"
            :sticky="true">
            <base-table-row
              v-for="(element) of allMkWithSubArrays[page - 1]"
              :key="`${element.id}hour-confirmation`"
              :columnTemplates="columnSize"
              :style="bookingsTags && Array.isArray(bookingsTags[element.id]) && bookingsTags[element.id].length ? 'position: relative; padding-bottom: 40px;' : ''"
              :bgRow="element.bgrow"
              >
              <base-table-column class="table-column_elipsis">
                <Copy :text="element.amoId" :textMessage="$t('mc.toasts.copyLink')"/>
                <a class="table-link" :href="element.amoId" target="_blank">{{element.amoId}}</a>
              </base-table-column>
              <base-table-column>
                <router-link :to="`/master-classes/detail/${element.id}`" target="_blank" v-tooltip="$t('mc.tooltips.detailMc')">
                  <inline-svg
                    class="icon-in-mk"
                    :src="require(`@/assets/svg/link.svg`)"/>
                </router-link>
              </base-table-column>
              <base-table-column>
                <span>{{element.date.date}}</span>
                <br>
                <span>{{element.date.time}}</span>
              </base-table-column>
              <base-table-column>
                {{$t('mc.tables.cols.parent')}}: {{element.parent}}
                <br>
                {{$t('mc.tables.cols.kid')}}: {{element.child.name}}, {{element.child.age}} {{$t('mc.tables.cols.age')}}
              </base-table-column>
              <base-table-column>
                <a
                  :href="`https://web.whatsapp.com/send?phone=${element.whatsapp}`">
                  {{element.whatsapp}}
                </a>
                <br>
                <a :href="`mailto:${element.email}`">{{element.email}}</a>
              </base-table-column>
              <base-table-column>
                <span
                  v-if="element.m1_confirmation_name"
                  :class="role === 'admin' && element.status.name !== 'Подтвержден'&& element.status.name !== 'Завершен' && element.status.name !== 'Отменен' && element.status.name !== 'В работе'
                    ? 'table-column-confirmed_by--active' : 'table-column-confirmed_by'"
                  @click="role === 'admin' && element.status.name !== 'Подтвержден'&& element.status.name !== 'Завершен' && element.status.name !== 'Отменен' && element.status.name !== 'В работе'
                  ? callModal({type:'changeM1', TC: element}) : null"
                >{{element.m1_confirmation_name}}</span>
              </base-table-column>
              <base-table-column>
                <span :class="['table-column-status', {'table-column-status_danger': element.status.name === $store.state.statuses.mcStatuses.cancel}]">
                  <inline-svg
                    class="table-column-status__icon"
                    :src="require(`@/assets/svg/${element.status.svg}.svg`)"/>
                  {{element.status_translated}}
                </span>
                <span
                  v-if="element.confirmation_details_translated"
                  class="table-column-status_hour-confirm">{{element.confirmation_details_translated}}</span>
              </base-table-column>
              <base-table-column>
                <div class="table-column-buttons">
                  <button
                    class="btn btn_success btn_square"
                    v-tooltip="$t('mc.tooltips.beforeHour')"
                    v-if="!element.hour_before_confirmed && element.status.name !== $store.state.statuses.mcStatuses.cancel"
                    @click="confirmBeforeHour(element.id)">
                    <inline-svg :src="require(`@/assets/svg/button-hour.svg`)"/>
                  </button>
                  <button
                    class="btn btn_white btn_square"
                    v-tooltip="$t('mc.tooltips.reshedule')"
                    v-if="element.status.name !== $store.state.statuses.mcStatuses.cancel"
                    @click="openModalReshedule(element.id, element.mk_starts_at, element.additional_info)">
                    <inline-svg :src="require(`@/assets/svg/button-reschedule.svg`)"/>
                  </button>
                  <button
                    class="btn btn_danger btn_square"
                    v-if="element.status.name !== $store.state.statuses.mcStatuses.cancel"
                    v-tooltip="$t('mc.tooltips.cancel')"
                    @click="openModalCancel(element.id)">
                    <inline-svg :src="require(`@/assets/svg/button-cancel.svg`)"/>
                  </button>
                </div>
              </base-table-column>
              <div style="position: absolute;bottom: 0;padding-left: 15px;" v-if="bookingsTags && Array.isArray(bookingsTags[element.id])">
                <Tags :show-title="false" :modify-ability="false" tags-wrapper-style="width: calc(100vw - 400px);" :prop-tags="bookingsTags[element.id]"></Tags>
              </div>
            </base-table-row>
          </base-table>
          <div class="pagination">
            <Count @changeCountsOnPage="changeCountsOnPage"/>
            <pagination
              v-model="page"
              :records="allMk.length"
              :per-page="perPage"
              :options="{texts: false}"
              @paginate = "setPage"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config"
import militaryAndLanguage from "@/helpers/militaryAndLanguage"
import booking from '@/api/master-classes/booking'
import globalSettingCalendar from '@/helpers/globalSettingCalendar'
import createSubarrays from "@/helpers/createSubarrays"
import scrollToContent from "@/helpers/scrollToContent"
import ReasonSelectAndComment from "@/components/ReasonSelectAndComment.vue"
import SelectDateMk from "@/components/MK/SelectDateMk.vue"
import Copy from '@/components/UI/Copy'
import Count from '@/components/UI/CountElementsOnPage'
import apiTags from "@/api/tags";
import AddMimk from '@/components/Manager/AddMimk.vue'
export default {
  components: {
    AddMimk,
    ReasonSelectAndComment,
    SelectDateMk,
    Copy,
    Count
  },
  data() {
    return {
      globalSettingCalendar,
      militaryAndLanguage,
      columnSize: '2fr 16px 2fr 3fr 3fr 100px 2fr 150px',
      role: '',
      selectedM1: {name: this.$t("mc.filters.all"), id: "all"},
      m1List: [],
      isAppoint: true,
      MasterClass: null,
      isModalVisible: false,
      triggerToDisableSaveButton: false,
      resheduleReason: '',
      resheduleComment: '',
      searchDate: '',
      allMk: [],
      allMkOriginal: [],
      allMkWithSubArrays: [],
      lossReasons: [],
      reason: '',
      loading: true,
      loadInModal: false,
      page: 1,
      perPage: 10,
      num_of_bookings_per_m1: 0,
      typePage: 'mc', //mc, search
      cancelModalVisible: false,
      resheduleModalVisible: false,
      reshedule: {
        mkIdForModal: '',
        startMkDate: '',
        additional_info: ''
      }
    }
  },
  computed: {
    bookingsTags() {
      return this.$store.state.tags.bookingsTagsObject
    },
    mimksTags() {
      return this.$store.state.tags.mimksTagsObject
    },
  },
  methods: {
    clearReason() {
      this.reason = ''
    },
    toggleTriggerSaveButtonToDisable(value) {
      this.triggerToDisableSaveButton = value
    },
    changeReason(reason) {
      this.reason = reason.actual
    },
    changeResheduleComment(resheduleComment) {
      this.resheduleComment = resheduleComment
    },
    setPage() {
      scrollToContent(this.$el.querySelector('.content'))
    },
    async loadM1List() {
      const uniqueM1Names = [...new Set(this.allMk.map(mk => mk.m1_confirmation_name).filter(Boolean))];
      this.m1List = [{ id: "all", name: this.$t("mc.filters.all") },
        ...uniqueM1Names.map(name => ({ id: name, name }))
      ];
    },
    async changeCountsOnPage(value) {
      this.perPage = value
      await this.loadMasterClasses(this.searchDate)
    },
    filterByM1() {
      if (this.selectedM1.id === "all") {
        this.allMk = [...this.allMkOriginal];
      } else {
        this.allMk = this.allMkOriginal.filter(mk =>
          mk.m1_confirmation_name?.trim() === this.selectedM1.name.trim()
        );
      }
      this.allMkWithSubArrays = createSubarrays(this.perPage, this.allMk);
    },
    async loadMasterClasses() {
      const isMilitaryTime = this.militaryAndLanguage()
      this.loading = true
      this.allMk = []

      const bgRows = {
        group1: ['#ece3ff', '#edd6ff', '#c7ffff', '#f6ffbd', '#fff491', '#ffe0bd', '#ffbde4'],
        group2: '#ffe8e8',
        group3: '#c7ffd7'
      }
      const allBgCounters = []
      bgRows.group1.forEach((el, index) => {
        if (index + 1 < 8) {
          allBgCounters.push(this.num_of_bookings_per_m1 * (index + 1))
        } else {
          return
        }
      })

      const MK = class {
        constructor(object, dayjs) {
          this.object = object
          this.dayjs = dayjs
        }

        returnObject() {
          return this.object.map((el, index) => {
            function bgRow() {
              if (el.confirmation_group === 1) {
                const indexCounters = allBgCounters.findIndex(el => el > index)
                const color = indexCounters != -1 ? bgRows.group1[indexCounters] : '#fff'
                return color
              }
              else if (el.confirmation_group === 2) {
                return bgRows.group2
              } else if (el.confirmation_group === 3) {
                return bgRows.group3
              }
            }
            let svgName = 'status-wait'
            if (el.status === 'Отменен') svgName = 'status-cancel'
            if (el.status === 'Завершен') svgName = 'status-complete'
            return {
              id: el.id,
              amoId: `${config.AMO_LINK}${el.amocrm_id}`,
              mk_starts_at: el.mk_starts_at,
              additional_info: el.additional_info,
              date: {
                date: this.dayjs(el.mk_starts_at, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY'),
                time: isMilitaryTime ? this.dayjs(el.mk_starts_at, 'YYYY-MM-DD HH:mm').format('HH:mm') : this.dayjs(el.mk_starts_at, 'YYYY-MM-DD HH:mm').format('hh:mm a'),
              },
              parent: el.parent_name,
              child: {
                age: el.kid_age,
                name: el.kid_name
              },
              bgrow: bgRow(),
              confirmation_details_translated: el.confirmation_details_translated,
              whatsapp: el.parent_whatsapp,
              email: el.parent_email,
              status: {
                svg: svgName,
                name: el.status,
                canceled: el.status === 'Отменен'
              },
              status_translated: el.status_translated,
              m1_confirmation_name: el.m1_confirmation_name,
              m1_confirmation: el.m1_confirmation,
              hour_before_confirmed: el.hour_before_confirmed,
              typeMk: this.typeMk
            }
          })
        }
      }

      let masterClasses = await booking.getClosest()
      this.allMk = [...new MK(masterClasses, this.$dayjs).returnObject()]
      this.allMkOriginal = [...this.allMk];

      //Tags Loader
      const bookingIds = this.allMk.map(booking => booking.id)
      if (bookingIds.length) apiTags.getBookingsTags(bookingIds, true)

      this.allMkWithSubArrays = createSubarrays(this.perPage, this.allMk)
      this.loading = false
    },
    openModalCancel(id) {
      this.reshedule.mkIdForModal = id
      this.cancelModalVisible = true
    },
    callModal({ type, TC }) {
      this.isModalVisible = true;
      this.MasterClass = TC;
      type === "changeM1"
        ? (this.isAppoint = false)
        : (this.isAppoint = true);
    },
    async closeMCModal(isRerender) {
      //При закрытии модалки убираем активный класс с выбранного мимка
      this.$refs.modalBody.removeCheckM1();
      this.isModalVisible = false;
      //Если закртие произошло после назначения МК, то делаем запрос на получения МК и перерендериваем страницу
      if (isRerender) {
        this.isLoad = true;
        await this.loadMasterClasses(this.searchDate)
        this.isLoad = false;
      }
    },
    openModalReshedule(id, startMkDate, additional_info) {
      this.reshedule.mkIdForModal = id
      this.reshedule.startMkDate = startMkDate
      this.reshedule.additional_info = additional_info
      this.resheduleModalVisible = true
    },
    async closeModals(value) {
      this.reshedule.mkIdForModal = ''
      this.reshedule.startMkDate = ''
      this.reshedule.additional_info = ''
      this.reason = ''
      this.cancelModalVisible = false
      this.resheduleModalVisible = false
      this.loadInModal = false
      if (value === 'reschedule') {
        await this.loadMasterClasses(this.searchDate)
      }
    },
    changeCallDate(value) {
      this.reshedule.callDate = value
    },
    async saveMkCancel() {
      this.loadInModal = true
      await booking.removeBooking(
        this.reshedule.mkIdForModal,
        `loss_reason=${this.reason}`
      ).then(async() => {
        this.closeModals()
        this.$toasted.global.all_ok(this.$t('mc.toasts.mcCanceled'))
        await this.loadMasterClasses(this.searchDate)
      }).catch(() => {
        this.loadInModal = false
      })
    },
    async confirmBeforeHour(id) {
      const confirm = await booking.updateBooking(id, {hour_before_confirmed:true})
      if (confirm) {
        const idx = this.allMk.findIndex(el => el.id === id)
        this.allMk[idx].hour_before_confirmed = true
        this.allMkWithSubArrays = createSubarrays(this.perPage, this.allMk)
        this.$toasted.global.all_ok(this.$t('mc.toasts.mcConfirmed'))
      }
    },
    async searchByAmoId(value) {
      if (value.length) {
        this.typePage = 'search'
        this.loadMasterClasses(false, value)
      } else {
        this.typePage = 'mc'
        this.loadMasterClasses(this.searchDate)
      }
    }
  },
  async created() {
    this.num_of_bookings_per_m1 = await booking.m1DistribRules()
    if (!localStorage.getItem('countsOnPage')) {
      this.perPage = 10
    } else {
      this.perPage = JSON.parse(localStorage.getItem('countsOnPage')).value
    }
    await this.loadMasterClasses()
    if (this.$store.state.user.user.role === 'admin') {
      await this.loadM1List()
    }
    this.lossReasons = this.$store.state.booking.lossReasons
    this.role = this.$store.state.user.user.role
  },
  watch: {
    async searchDate(date) {
      //Чистим поисковую строку и строим таблицу
      this.$refs.headerPage.clearAmoId()
      await this.loadMasterClasses(date)
    }
  }
}
</script>

<style lang="scss" scoped>
.notice {
  display: block;
  margin: 16px 0;
}
.modal {
  &-cancel {
    &-text {
      display: block;
      margin-bottom: 20px;
    }
  }
  &-reshedule {
    &-text {
      display: block;
      margin: 20px 0;
    }
    &-time {
      margin-top: 24px;
      margin-bottom: 20px;
      width: 100px;
    }
  }
}

.table-column-confirmed_by {

  &--active {
    color: var(--main-blue);
    cursor: pointer;
  }
}
</style>
